/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-01-15 17:21:40
 * @LastEditTime: 2021-07-13 17:43:02
 */
import request from '@/utils/request';
var baseUrl = '/rest/ysh/wx/v_718'; // 录播课详情页

export var recordCourseDetail = function recordCourseDetail(data) {
  return request({
    url: '/rest/course/recordCourseDetail',
    method: 'post',
    data: data
  });
}; // 直播课详情页

export var livingCourseDetail = function livingCourseDetail(data) {
  return request({
    url: '/rest/course/livingCourseDetail',
    method: 'post',
    data: data
  });
}; // 报名

export var signUp = function signUp(data) {
  return request({
    url: '/rest/course/signUp',
    method: 'post',
    data: data
  });
}; // 签到

export var signIn = function signIn(data) {
  return request({
    url: '/rest/course/signIn',
    method: 'post',
    data: data
  });
};
export var sendGift = function sendGift(data) {
  return request({
    url: '/rest/course/sendFlower',
    method: 'post',
    data: data
  });
};
export var commentList = function commentList(data) {
  return request({
    url: '/rest/course/commentList',
    method: 'post',
    data: data
  });
};
export var sendComment = function sendComment(data) {
  return request({
    url: '/rest/course/comment',
    method: 'post',
    data: data
  });
}; // 直播详情-获得分享邀请卡列表

export var selectByInvitatioList = function selectByInvitatioList(data) {
  return request({
    url: "".concat(baseUrl, "/invitatio/selectByInvitatioList"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 查询菜单下的内容

export var selectByCourseMenuList = function selectByCourseMenuList(data) {
  return request({
    url: "".concat(baseUrl, "/course/selectByCourseMenuList"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 添加问卷答题

export var questionnaireInsert = function questionnaireInsert(data) {
  return request({
    url: "".concat(baseUrl, "/course/questionnaireInsert"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 根据问卷id查询问卷信息

export var SelectByQuestionnaireOne = function SelectByQuestionnaireOne(data) {
  return request({
    url: "".concat(baseUrl, "/course/SelectByQuestionnaireOne"),
    method: 'post',
    data: data
  });
}; // 查询观看限制信息

export var queryViewingCheckInfo = function queryViewingCheckInfo(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadShare/queryViewingCheckInfo"),
    method: 'post',
    data: data
  });
}; // 直播视频信息列表

export var querychannelCourseList = function querychannelCourseList(data) {
  return request({
    url: "".concat(baseUrl, "/channelCourse/querychannelCourseList"),
    method: 'post',
    data: data
  });
}; // 直播详情-自定义菜单查询

export var queryliveZdyMenuList = function queryliveZdyMenuList(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/queryliveZdyMenuList"),
    method: 'post',
    data: data
  });
}; // 详情页-获得关联多流接口

export var getCourseRela = function getCourseRela(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/getCourseRela"),
    method: 'post',
    data: data
  });
}; // 详情

export var courseDetail = function courseDetail(data) {
  return request({
    url: "".concat(baseUrl, "/contentManage/courseDetail"),
    method: 'post',
    data: data
  });
}; // 根据直播id、专区id查询是否有抽奖

export var queryChannelZhiboRaffle = function queryChannelZhiboRaffle(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/queryChannelZhiboRaffle"),
    method: 'post',
    data: data
  });
}; // 提交观看限制问卷

export var addByWatchCheck = function addByWatchCheck(data) {
  return request({
    url: "".concat(baseUrl, "/watchCheck/addByWatchCheck"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 直播详情-根据专区id和课程id查询直播配置信息 活动

export var queryChannelZhiboConf = function queryChannelZhiboConf(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/queryChannelZhiboConf"),
    method: 'post',
    data: data
  });
}; // 直播详情-查询课程信息

export var queryChannelCourse = function queryChannelCourse(data) {
  return request({
    url: "".concat(baseUrl, "/course/detail"),
    method: 'post',
    data: data
  });
}; // 直播详情-根据传入抽奖id、用户id 获得抽奖结果

export var queryDrawResults = function queryDrawResults(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadShare/queryDrawResults"),
    method: 'post',
    data: data
  });
}; // 直播详情-分享直播课

export var queryLiveShareCourseList = function queryLiveShareCourseList(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadShare/queryLiveShareCourseList"),
    method: 'post',
    data: data
  });
}; // 查询该用户是否已经提交过限制问卷答案

export var queryUserInfoAnswer = function queryUserInfoAnswer(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadShare/queryUserInfoAnswer"),
    method: 'post',
    data: data
  });
}; // 提交保存中奖人信息

export var saveraffleWinnerInfo = function saveraffleWinnerInfo(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadShare/saveraffleWinnerInfo"),
    method: 'post',
    data: data
  });
}; // 查询奖品信息

export var queryCourseRaffleConfigInfo = function queryCourseRaffleConfigInfo(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/queryCourseRaffleConfigInfo"),
    method: 'post',
    data: data
  });
}; // 查询判断用户是否已抽奖

export var queryCheckZhiboRaffleInfi = function queryCheckZhiboRaffleInfi(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/queryCheckZhiboRaffleInfi"),
    method: 'post',
    data: data
  });
}; // 问卷查询

export var questionnaireList = function questionnaireList(data) {
  return request({
    url: "".concat(baseUrl, "/liveBroadZdyMenu/questionnaireList"),
    method: 'post',
    data: data
  });
}; // 搜索有内容的菜单

export var querychannelCourseMenuInfo = function querychannelCourseMenuInfo(data) {
  return request({
    url: "".concat(baseUrl, "/channelCourse/querychannelCourseMenuInfo"),
    method: 'post',
    data: data
  });
};
/****************************************************专区****************************************************************/
// 查询专区下的菜单

export var selectByChannelList = function selectByChannelList(data) {
  return request({
    url: "".concat(baseUrl, "/channelMenus/selectByChannelList"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 专区视频、直播菜单下数据

export var selectByChannelMenu = function selectByChannelMenu(data) {
  return request({
    url: "".concat(baseUrl, "/channelMenus/selectByChannelMenu"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 专区咨询菜单下数据

export var selectByMenuConsult = function selectByMenuConsult(data) {
  return request({
    url: "".concat(baseUrl, "/channelMenus/selectByMenuConsult"),
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
};